/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:14:46
 */
export default {
  lang: "英语",
  landing: {
    name1: "فتح Carlcare",
    name2: "إجراء حجز",
    name3: "مع Carlcare ، يمكنك التحقق من طلبك في أي وقت.",
    name4: "",
    name5: "مرر إلى اليمين",
    name6: "اكتمل التحقق",
        name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02150880282.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
        name40: "Exclusive for",
    name41: "Jakarta Pusat!",
    name42: "Reservation Now",
    name43: "What is Carlcare Home Service ?",
    name44: "1.Carlcare Home Service is available for TECNO, Infinix, and itel users.",
    name45: "2.Enjoy convenient and efficient repair services anywhere (at home, in the office, at a café, on campus, or outdoors), saving you time and effort.",
    name46: "Why do we recommend choosing Carlcare Home Service ?",
    name47: "Free Home Service Charges",
    name48: "No home service fees required.",
    name49: "*For out of warranty or accidental damage, pay for parts and labor.",
    name50: "Easy Booking",
    name51: "Easily book through Carlcare App, website, hotline, or WhatsApp.",
    name52: "Safe & Reliable",
    name53: "With strict safety measures, ensuring your device is in trusted hands.",
    name54: "Official Support",
    name55: "All repairs by Carlcare official engineers use only original spareparts.",
    name56: "Ways to Book Carlcare Home Service",
    name57: "1. Open the Carlcare App",
    name58: '2. Tap "Reservation"',
    name59: '3. Choose "Carlcare Home Service"',
    name60: "4. Select your current location",
    name61: "5. Fill in the required details to complete the reservation",
    name62: "1. Open the Carlcare Official Website:https://www.carlcare.com/id/",
    name63: '2. Tap "Perbaiki Telepon"',
    name64: '3. Choose "Carlcare Home Service"',
    name65: "4. Select your current location",
    name66: "5. Fill in the required details to complete the reservation",
    name67: "Call Carlcare hotline: 021 5088 0282 to book Carlcare Home Service.",
    name68: "Contact Carlcare WhatsApp Business Account:+62-812-9009-0559 to Carlcare Home Service.",
    name69: "1.Device needs repair.",
    name70: "2.Book Carlcare Home Service.",
    name71: "3.Engineer contacts you to confirm the appointment time.",
    name72: "4.Engineer arrives at the scheduled time.",
    name73: "5.Complete the repair and make the payment.",
    name74: "Statement:",
    name75: "1.Free Home Service applies to service fees only. ",
    name76: "①Under Warranty: Enjoy free home service and repairs;",
    name77: "②Out of Warranty:Only pay for labor and spareparts,no extra home service charges.",
    name78: "2.Carlcare Home Service is currently limited to the the Jakarta Pusat and will gradually expand to more regions in the future. Please Stay tuned!",
    name79: "3.The final explanation of the activity belongs to Carlcare.",
    name80: "App",
    name81: "Website",
    name82: "Hotline",
    name83: "WhatsApp",
    name84: "No door-to-door fee",
    name85: "Service Process:",
    name86: "Book Carlcare",
    name87: "Home Service",
    name88: " Today!",
  },
  order: {
    name1: "اختر طراز الجهاز",
    name2: "وصف العطل:",
    name3: "انقر لتحديد متجر الخدمة",
    name4: "متجر الخدمة:",
    name5: "وقت الحجز:",
    name6: "يرجى وصف مشكلة جهازك بالتفصيل!",
    name7: "انقر لتحديد وقت الوصول",
    name8: "يرجى إدخال تفاصيل الاتصال الصحيحة الخاصة بك حتى نتمكن من الوصول إليك",
    name9: "الوقت المتاح للحجز على النحو التالي",
    name10: "برجاء إدخال رقم هاتفك",
    name11: "السعر",
    name12: "المعلومات الشخصية:",
    name13: "يرجى إدخال اسمك",
    name14: "إرسال",
    name15: "إلغاء",
    name16: "موافق",
  },
  shops: {
    name1: "بناءً على العلامة التجارية التي أخترتها، هذة المتاجر يمكنها خدمتك!",
    name2: "ترقبوا فتح المزيد من متاجر البيع بالتجزئة",
  },
  price: {
    name1: "علامة تجارية",
    name2: "الطراز",
    name3: "عنصر",
    name4: "السعر",
    name5: "تذكير ودي:",
    name6: "هذه الأسعار للإشارة فقط ، والسعر الفعلي يخضع لحالة جهازك.",
    name7: "إذا لم يكن هناك رمز خاص ، فإن وحدة السعر هي وحدة العملة المحلية.",
    name8: "آسف! لا توجد معلومات عن الأسعار المتاحة في المنطقة الحالية.",
    name11:"تكلفة العمالة",
    name12:"السعر الكلي",
    name13: "٥. إذا كانت تكلفة العمالة هي \"/\"، فهذا يعني أنه يجب استشارة تكلفة العمالة مع المتجر.",
    item_main_board: "اللوحة الرئيسية",
    item_screen_frame: "‏شاشة (إطار)‏",
    item_screen_screen_frame: "‏الشاشة الثانوية‏ (إطار)",
    item_touch_screen: "شاشة اللمس",
    item_camera: "كاميرا",
    item_fixed_focus_camera: "‏كاميرا ذات تركيز ثابت‏",
    item_auto_focus_camera: "‏كاميرا التركيز التلقائي‏",
    item_screen: "الشاشة",
    item_secondary_screen: "‏الشاشة الثانوية‏",
    item_fingerprint_module: "‏وحدة بصمة الإصبع‏",
    item_speaker: "مكبر الصوت",
    item_receiver: "\"مستلم\"",
    item_small_board: "‏لوحة صغيرة‏",
    item_battery_cover: "‏غطاء البطارية‏",
    item_battery: "البطارية",
    item_charger: "شاحن",
    item_usb_cable: "‏كابل USB‏",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "لايوجد بيانات",
    name2: "مزوِّد الخدمة:",
    name3: "العلامة التجارية للخدمة:",
    name4: "الهاتف :",
    name5: "كمية الطلب:",
    name6: "تقييم الخدمة",
    name7: "بيئة الخدمة:",
    name8: "توجه الخدمة:",
    name9: "كفاءة الخدمة:",
    name10: "جودة الخدمة:",
    name11: "تقييم العميل",
    name12:"إلى",
    name13:"تم الإغلاق",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "فتح Carlcare",
    name1: "يرجى تصوير معلومات الحجز وحفظها كإيصال للوصول إلى الخدمة ذات الأولوية.",
    name2: "تم التقديم بنجاح",
    name3: "١. تنظيف البيانات",
    name4: "يرجى إجراء نسخ احتياطي للبيانات الخاصة الهامة الموجودة على هاتفك مسبقًا",
    name5: "٢. قم بتعطيل كلمة مرور بدء التشغيل",
    name6: "قبل الذهاب إلى متجر الخدمة ، من فضلك:",
    name7: "متجر الخدمة:",
    name8: "وقت الحجز:",
    name9: "وصف العطل:",
    name10: "طراز الجهاز:",
    name11: "رقم الطلب:",
    name12: "معلومات عن الطلب",
  },
  title: {
    name1: "يدعم البلدان التالية:",
    name2: "حدد الطراز",
    name3: "الاحتفاظ",
    name4: "تفاصيل متجر الخدمة",
    name5: "حدد متجر الخدمة",
  },
  error: {
    name1: "لايوجد بيانات. يرجى التحقق من معلومات الإصلاح الخاصة بك",
    name2: "يرجى التواصل معنا في حال احتجت للمزيد من المساعدة",
    name3: "عذرا ، لا يوجد مركز Carlcare في المنطقة الحالية.",
    name4: "الرجاء اختيار مركز الخدمة أولا",
    name5: "فشل",
    name6: "الرجاء اختيار طراز الجهاز أولاً",
    name7: "التفاصيل",
    name8: "يرجى وصف احتياجاتك بالتفصيل",
    name9: "",
  },
  add1:{
    "name0": "ar",
    "name1": "تم تأكيد طلبك. نحن نتطلع إلى وصولك.",
    "name2": "تحديد مدينة",
    "name3": "يرجى إدخال رقم هاتف مكون من %1$s رقمًا.",
    "name4": "ساعات العمل خلال أيام الأسبوع",
    "name5": "الاثنين",
    "name6": "الثلاثاء",
    "name7": "الأربعاء",
    "name8": "الخميس",
    "name9": "الجمعة",
    "name10": "السبت",
    "name11": "الأحد",
    "name12": "أدخل البلد والبحث"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "آخرون",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"انقر لإعادة التوجيه",
    name3:"افتح تطبيق Carlcare لتقييم الطلب",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"اختر الخدمة",
    name7:"تنظيف مجاني",
    name8:"ترقية البرامج",
  },
  cancelorder:{
    "cancelReason0": "معلومات غير صحيحة",
    "cancelReason1": "لا يمكن الوصول في الوقت المحدد",
    "cancelReason2": "طلب مكرر / ليس طلبي",
    "cancelReason3": "لا يتكرر الفشل",
    "cancelReason4": "فقط للاختبار/الاستفسار/ الحدث/ …",
    "cancelReason5": "غالي السعر",
    "cancelReason6": "نقص في المواد ",
    "cancelReason7": "لا يوجد خدمات مميزة",
    "cancelReason8": "المتجر بعيد للغاية ",
    "cancelReason9": "المتجر مغلق",
    "cancelReason10": "موقف الخدمة السيئة",
    "cancelReason11": "استبدال/إصلاح لماركات أخرى",
    "cancelReason12": "لا يمكن العثور على المتجر",
    "cancelReason13": "أخرى",
    "cancelOrder": "إلغاء طلب الشراء",
    "reason_dialog_title": "يرجى إخبارنا عن سبب الإلغاء ",
    "Cancel": "إلغاء",
    "OK": "حسناً",
    "name1": "أدخل رمز التحقق",
    "name2": "رمز التحقق غير صالح",
    "repair_reservation_detail_canceled": "لقد تم إلغاء هذا الطلب!",
    "purchase_cancel_dialog_content": "هل تؤكد إلغاء الطلب؟",
    "yes": "نعم",
    "no": "لا"
}
};
